import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Modal } from "react-bootstrap";
import Select from "react-select";
import "./popup.css";
import swal from "sweetalert";
import { AES, enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import "./RecurringInvoiceNew.css";
import Alert from "@mui/material/Alert";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function RecurringInvoiceNew({ navigation }) {
  const [row, setRow] = useState([
    {
      itemDetails: "",
      itemCode:"",
      hsnSac: "",
      per:"1",
      quantity: "1",
      rate: "0.0",
      discount: "0.0",
      discountType: "₹",
      description1: "",
      description2: "",
    },
  ]);

  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleEditorChange = (value) => {
    setTermsAndCondition(value); // Update the state with the content of the editor
  };

  useEffect(() => {
    // Update the current date format when the component mounts
    const formattedDate = formatDate(new Date());
    setCurrentDate(formattedDate);
  }, []);

  const formatDate = (date) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = date.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const jwtToken = localStorage.getItem("jwtToken");

  const handleAdd = () => {
    const newItem = {
      itemDetails: "",
      itemCode:"",
      per:"1",
      quantity: "1",
      rate: 0,
      discount: 0,
      discountType: "₹",
      tax: 0,
    };
    const newRow = [...row, newItem];
    setRow(newRow);
  };

  const handleTaxChange = (e, index) => {
    setSelectedTaxRate(e.target.value);
    const newTaxRate = parseFloat(e.target.value);
    const updatedRow = [...row];
    updatedRow[index].tax = newTaxRate;
    setRow(updatedRow);
  };

  const handleDeleteRow = (i) => {
    const updatedRow = [...row];
    updatedRow.splice(i, 1);
    setRow(updatedRow);
    updateTotal(updatedRow);
  };

  const handleNavigation = (key) => {
    if (navigation.state.routes[navigation.state.index].key !== key) {
      navigation.navigate(key);
    }
  };

  const handleCancleClick = () => {
    const confirmCancel = window.confirm("Are you sure Leave this page?");
    if (confirmCancel) {
      // Code to handle cancellation
      handleNavigation("RecurringInvoices");
    } else {
      // Code to handle cancellation not confirmed
      console.log("Cancellation not confirmed");
    }
  };

  const [show1, setShow1] = useState(false);
  const [selectedTerms, setSelectedTerms] = useState("");
  const [selectedPaymentTerms, setSelectedPaymentTerms] = useState("");
  const [selectTermsDays, setSelectTermsDays] = useState("");
  const [bussinessRegistered, setBussinessRegistered] = useState("");
  const [discountCheck, setDiscountCheck] = useState("");
  const [quantityCheck,setQuantityCheck] = useState("");

  const handleTermsChange = (selectedOption) => {
    setSelectedTerms(selectedOption.value);
  };

  const handleDiscountChange = (e, i) => {
    const { name, value } = e.target;
    const newValues =
      name === "discount" ? { discount: value } : { discountType: value };
    const newRow = [...row];
    newRow[i] = { ...newRow[i], ...newValues };
    setRow(newRow);
    updateTotal(newRow);
  };

  const handleQuantityChange = (e, i) => {
    const newQuantity = e.target.value;
    const newRow = [...row];
    newRow[i] = { ...newRow[i], quantity: newQuantity };
    setRow(newRow);
    updateTotal(row);
  };

  const handleRateChange = (e, i) => {
    const newRate = e.target.value;
    const newRow = [...row];
    newRow[i] = { ...newRow[i], rate: newRate };
    setRow(newRow);
    updateTotal(row);
  };

  const updateTotal = (rowData) => {
    let calculatedTotal = 0;
    rowData.forEach((data) => {
      const amount = calculateAmount(data);
      calculatedTotal += parseFloat(amount);
    });
    setTotal(calculatedTotal.toFixed(2));
  };

  const [total, setTotal] = useState(0);

  const calculateAmount = (data, tax) => {
    const { quantity, rate, discount, discountType } = data;
    let amount = quantity * rate;
    if (discount) {
      amount -= discountType === "%" ? (amount * discount) / 100 : discount;
    }
    return amount;
  };

  const calculateTAX = (data) => {
    const { tax } = data;
    let totalTAX = 0;
    if (tax > 0) {
      const amount = calculateAmount(data);
      const increasedTaxAmount = (parseFloat(amount) * tax) / 100;
      totalTAX = increasedTaxAmount;
    }
    return totalTAX.toFixed(2);
  };

  const calculateDisRupees = (data, taxRate) => {
    const quantity = parseFloat(data.quantity || 0);
    const rate = parseFloat(data.rate || 0);
    const discount = parseFloat(data.discount || 0);
    const amount = quantity * rate;
    let discountedAmount = 0;
    if (data.discountType === "%") {
      discountedAmount = (amount * discount) / 100;
    } else if (data.discountType === "₹") {
      discountedAmount = discount;
    }

    return discountedAmount.toFixed(2);
  };

  const [selectedTaxRate, setSelectedTaxRate] = useState(0);

  //CalculateTaxAmount
  const calculateTaxAmount = (amount, taxRate) => {
    if (taxRate > 0) {
      let taxIncrease = 0;

      // Set tax increase based on tax rate
      switch (taxRate) {
        case 0.05:
          taxIncrease = 0.5;
          break;
        case 0.12:
          taxIncrease = 1.0;
          break;
        case 0.18:
          taxIncrease = 1.5;
          break;
        case 0.28:
          taxIncrease = 2.0;
          break;
        default:
          break;
      }

      return amount * (taxRate + taxIncrease);
    }
    return 0;
  };

  const calculateSubTotal = () => {
    let subTotal = 0;
    row.forEach((data) => {
      const amount = calculateAmount(data);
      subTotal += parseFloat(amount);
    });
    return subTotal.toFixed(2);
  };

  const calculateIGST = () => {
    let totalIGST = 0;
    row.forEach((data) => {
      const taxRate = parseFloat(data.tax || 0);
      if (taxRate > 0) {
        const amount = calculateAmount(data, taxRate);
        const increasedTaxAmount = (parseFloat(amount) * taxRate) / 100;
        totalIGST += increasedTaxAmount;
      }
    });
    return totalIGST.toFixed(2);
  };

  const calculateSGSTandCGST = () => {
    let totalSGST = 0;
    let totalCGST = 0;

    row.forEach((data) => {
      const taxRate = parseFloat(data.tax || 0);
      const amount = calculateAmount(data, taxRate);
      // const increasedTaxAmount = parseFloat(amount) - amount / (1 + taxRate);
      const increasedTaxAmount = (parseFloat(amount) * taxRate) / 100;
      const sgst = increasedTaxAmount / 2;
      const cgst = increasedTaxAmount / 2;
      totalSGST += sgst;
      totalCGST += cgst;
    });
    return {
      totalSGST: totalSGST.toFixed(2),
      totalCGST: totalCGST.toFixed(2),
    };
  };

  const calculateGroupedSGSTandCGST = () => {
    const taxGroups = row.reduce((acc, data) => {
      const taxRate = parseFloat(data.tax / 100 || 0);
      if (taxRate === 0) return acc; // Skip 0% GST

      const amount = calculateAmount(data, taxRate);
      const increasedTaxAmount = amount * taxRate;
      const sgst = increasedTaxAmount / 2;
      const cgst = increasedTaxAmount / 2;

      if (!acc[taxRate]) {
        acc[taxRate] = { totalSGST: 0, totalCGST: 0 };
      }

      acc[taxRate].totalSGST += sgst;
      acc[taxRate].totalCGST += cgst;

      return acc;
    }, {});

    return taxGroups;
  };

  const calculateIGSTForTax = () => {
    const taxResults = [];

    row.forEach((data) => {
      const taxRate = parseFloat(data.tax / 100 || 0);
      if (taxRate > 0) {
        let existingTaxResult = taxResults.find(
          (result) => result.taxRate === taxRate
        );
        if (!existingTaxResult) {
          existingTaxResult = { taxRate, totalIGST: 0 };
          taxResults.push(existingTaxResult);
        }
        const amount = calculateAmount(data, taxRate);
        const increasedTaxAmount = amount * taxRate;
        existingTaxResult.totalIGST += increasedTaxAmount;
      }
    });
    return taxResults;
  };

  const [adjustmentValue, setAdjustmentValue] = useState(""); // Step 1: State for adjustment value
  const [oppositeValue, setOppositeValue] = useState(""); // State for opposite value
  const [profileName, setProfileName] = useState("");

  const totalTax =
    calculateIGST() ||
    calculateSGSTandCGST().totalSGST + calculateSGSTandCGST().totalCGST;
  const [disAllValue, setDisAllValue] = useState("");
  const [discountType, setDiscountType] = useState("₹");
  const [disValue, setDisValue] = useState("");

  const calculateDiscount = () => {
    const amount = parseFloat(calculateSubTotal()).toFixed(2);

    if (discountType === "₹") {
      setDisValue(disAllValue);
    } else if (discountType === "%") {
      const percentageDiscount = (amount * disAllValue) / 100;
      setDisValue(percentageDiscount.toFixed(2));
    }
  };

  const handleDiscountTypeChange = (e) => {
    setDiscountType(e.target.value);
  };

  const handleDisAllValueChange = (e) => {
    setDisAllValue(e.target.value);
  };

  useEffect(() => {
    calculateDiscount();
  }, [disAllValue, discountType]);

  useEffect(() => {
    const parsedValue = parseFloat(adjustmentValue);
    if (!isNaN(parsedValue)) {
      // Calculate the opposite value only if the adjustmentValue is a valid number
      const opposite = parsedValue * 1;
      setOppositeValue(opposite.toFixed(2));
    } else {
      // If adjustmentValue is not a valid number, set the opposite value to an empty string
      setOppositeValue("");
    }
  }, [adjustmentValue]);

  const calculateTotal = () => {
    const subTotal = parseFloat(calculateSubTotal());
    const igst = parseFloat(calculateIGST());
    const adjustment = parseFloat(adjustmentValue) || 0; // Use the adjustment value if it's a valid number, otherwise, default to 0
    const total1 = subTotal + igst + adjustment;
    const total = total1 - disValue;
    return total.toFixed(2);
  };

  const fetchSalesData = () => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    fetch(BASE_URL + `/getAllSalesPersonByUniqueId`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const filteredData = data.responseMessage.filter(
            (item) => item.name !== "Others"
          );
          setSalesPersonData(filteredData);
        } else {
          console.error("Failed to fetch salesperson:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching salesperson:", error);
      });
  };
  useEffect(() => {
    fetchSalesData();
    fetchTermsData();
  }, []);

  const [custNames, setCustNames] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(""); // State to store the selected customer's ID

  // Fetch customer data
  const fetchAllCustomers = () => {
    fetch(BASE_URL + `/getAllCustomerName`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          setCustNames(data.responseMessage);
        } else {
          console.error("Failed to fetch Customer Name:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
      });
  };

  useEffect(() => {
    fetchAllCustomers();
  }, []);

  useEffect(() => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    fetch(BASE_URL + `/fetchGst`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          const Data = data.responseMessage[0].businessRegistered;
          setBussinessRegistered(Data);
        } else {
          console.error("Failed to fetch Customer Name:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
      });
  }, []);

  useEffect(() => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    fetch(BASE_URL + `/fetchDiscountCheck`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          const Data = data.responseMessage.discountCheck;
          setDiscountCheck(Data);
          setQuantityCheck(data.responseMessage.quantityCheck);
        } else {
          console.error("Failed to fetch Customer Name:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching Customer Name:", error);
      });
  }, []);

  const [userState, setUserState] = useState([]);
  const [customerState, setCustomerState] = useState("");

  const apiUrl = BASE_URL + `/fetchUserProfile`;
  const userId = localStorage.getItem("userId");

  const fetchData = () => {
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, userId: userId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const userState = data.responseMessage;

          setUserState(userState);
        } else {
          console.error("Error fetching portfolio data");
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle customer selection
  const handleCustomerChange = (value, id) => {
    const selectedValue = value;
    const selectedValueId = id;
    setSelectedCustomer(selectedValue);
    setSelectedCustomerId(selectedValueId);

    // Find the selected customer object in the fetched data
    const selectedCustomerObject = custNames.find(
      (person) => person.customerName === selectedValue
    );

    if (selectedCustomerObject) {
      const customerState = selectedCustomerObject.billState;
      setCustomerState(customerState);
      setSelectedCustomerId(selectedCustomerObject.id);
    } else {
      console.log("Selected Customer: (Not found)");
    }
  };

  const handleSalesPersonChange = (value, id) => {
    const selectedValue = value;
    setSelectedSalesPerson(selectedValue);

    const selectedSalesPersonObject = salesPersonData.find(
      (person) => person.name === selectedValue
    );
  };

  const [invoiceNumberPrefix, setInvoiceNumberPrefix] = useState([]);
  const [invoiceNumberNext, setInvoiceNumberNext] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [adjustmentLabel, setAdjustmentLabel] = useState("");
  const [customerNote, setCustomerNote] = useState("");
  const [termsAndCondition, setTermsAndCondition] = useState("");
  const [salesPersonData, setSalesPersonData] = useState([]);
  const [selectedSalesPerson, setSelectedSalesPerson] = useState("");
  const encryptedUniqueId = localStorage.getItem("uniqueId1");

  // Decrypt the uniqueId using your decryption method
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);

  const [validationMessage1, setValidationMessage1] = useState("");

  const insertDataIntoDatabase = async () => {
    const itemDetails = row.map((data) => {
      const amount1 = calculateAmount(data, data.tax);
      const taxinAmount = calculateTAX(data);
      const totalAmountWithTax = parseFloat(amount1) + parseFloat(taxinAmount);
      return {
        itemDetails: data.itemDetails || "", // Assuming you have an input for itemDetails
        hsnSac: data.hsnSac,
      itemCode: data.itemCode || "",
        quantity: data.quantity,
        per:data.per,
        rate: data.rate,
        discount: data.discount || 0,
        discountType: data.discountType,
        tax: selectedTaxRate, // Assuming the tax rate is the same for all items
        amount: amount1,
        rowWiseTotalWithGST: totalAmountWithTax.toFixed(2),
        rowDiscount: calculateDisRupees(data),
        description1: data.description1 || "",
        description2: data.description2 || "",
        customerTaxType: userState.state === customerState ? 1 : 2,
        cgst:
          userState.state === customerState
            ? (calculateAmount(data, selectedTaxRate) * data.tax) / 100 / 2
            : 0,
        sgst:
          userState.state === customerState
            ? (calculateAmount(data, selectedTaxRate) * data.tax) / 100 / 2
            : 0,
        igst:
          userState.state !== customerState
            ? (calculateAmount(data, selectedTaxRate) * data.tax) / 100
            : 0,
      };
    });
    const formData = {
      uniqueId: decryptedUniqueId,
      customerName: selectedCustomer,
      profileName: profileName,
      customerId: selectedCustomerId,
      invoiceNumber: invoiceNumber,
      invoiceDate: invoiceDate,
      paymentTerms: selectedPaymentTerms,
      repeatEvery: calculateValue() || calculateDays(),
      repeatEveryInWords: selectedTerms,
      startOn: dateValue || normalDateFormat(startDate),
      endsOn: dateValue1 || normalDateFormat(startDate1),
      neverExpires: neverExpiresCheck,
      salesPerson: selectedSalesPerson,
      orderNumber: orderNumber,
      subject: subject,
      items: itemDetails,
      subTotal: calculateSubTotal(),
      adjustment: parseFloat(adjustmentValue) || 0,
      adjustmentLabel: adjustmentLabel,
      total: calculateTotal(),
      customerNotes: customerNote,
      receivables: calculateTotal(),
      taxInAmount: totalTax || 0,
      termsAndConditions: termsAndCondition,
      totalAmount: calculateTotal() || 0,
      discountCheck: discountCheck || 0,
      quantityCheck:quantityCheck,
      overallDiscount: disAllValue || 0,
      taxCheck: bussinessRegistered || 0,
      totalDiscount: disValue || 0,
      overallDiscountType: discountType || 0,
      status: "Sent",
      manualCheck: "No",
      state: customerState,
    };
    let newValidationMessage = "";
    if (!formData.customerName) {
      newValidationMessage += "Please select a customer \n";
    } else if (!formData.startOn) {
      newValidationMessage += "Please enter invoice date.\n";
    } else if (!formData.orderNumber) {
      newValidationMessage += "Please enter order number.\n";
    }
    row.forEach((item, index) => {
      if (
        item.itemDetails.trim() === "" ||
        item.rate.trim() === "" ||
        item.rate.trim() === "0.0" ||
        item.quantity.trim() === ""
      ) {
        newValidationMessage +=
          "Enter the valid item name, rate and quantity.\n";
      }
    });

    setValidationMessage1(newValidationMessage);

    // Display a single validation alert if necessary
    if (newValidationMessage) {
      window.scrollTo(0, 0); // Scroll to top
      return;
    }
    setIsLoading(true);
    const response = await fetch(BASE_URL + `/insertRecurring`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "Recurring Invoice Created",
          });
          handleNavigation("RecurringInvoices");
          setIsLoading(false);
        } else if (data.status === "error") {
          swal({
            icon: "error",
            title: data.responseMessage,
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: error.message,
        });
        setIsLoading(false);
      });
  };

  const insertDataIntoDatabaseAsDraft = async () => {
    const itemDetails = row.map((data) => {
      const amount1 = calculateAmount(data, data.tax);
      const taxinAmount = calculateTAX(data);
      const totalAmountWithTax = parseFloat(amount1) + parseFloat(taxinAmount);
      return {
        itemDetails: data.itemDetails || "", // Assuming you have an input for itemDetails
        hsnSac: data.hsnSac,
      itemCode: data.itemCode || "",
        per:data.per,
        quantity: data.quantity,
        rate: data.rate,
        discount: data.discount || 0,
        discountType: data.discountType,
        tax: selectedTaxRate, // Assuming the tax rate is the same for all items
        amount: amount1,
        rowWiseTotalWithGST: totalAmountWithTax.toFixed(2),
        rowDiscount: calculateDisRupees(data),
        description1: data.description1 || "",
        description2: data.description2 || "",
        customerTaxType: userState.state === customerState ? 1 : 2,
        cgst:
          userState.state === customerState
            ? (calculateAmount(data) * data.tax) / 100 / 2
            : 0,
        sgst:
          userState.state === customerState
            ? (calculateAmount(data) * data.tax) / 100 / 2
            : 0,
        igst:
          userState.state !== customerState
            ? (calculateAmount(data) * data.tax) / 100
            : 0,
      };
    });
    const formData = {
      uniqueId: decryptedUniqueId,
      customerName: selectedCustomer,
      profileName: profileName,
      customerId: selectedCustomerId,
      invoiceNumber: invoiceNumber,
      invoiceDate: invoiceDate,
      paymentTerms: selectedPaymentTerms,
      repeatEvery: calculateValue() || calculateDays(),
      startOn: dateValue || normalDateFormat(startDate),
      endsOn: dateValue1 || normalDateFormat(startDate1),
      neverExpires: neverExpiresCheck,
      salesPerson: selectedSalesPerson,
      orderNumber: orderNumber,
      subject: subject,
      items: itemDetails,
      subtotal: calculateSubTotal(),
      adjustment: parseFloat(adjustmentValue) || 0,
      adjustmentLabel: adjustmentLabel,
      total: calculateTotal(),
      customerNotes: customerNote,
      receivables: calculateTotal(),
      taxInAmount: totalTax || 0,
      termsAndConditions: termsAndCondition,
      totalAmount: calculateTotal() || 0, // Assuming you have a function to calculate the total amount
      discountCheck: discountCheck || 0,
      overallDiscount: disAllValue || 0,
      taxCheck: bussinessRegistered || 0,
      totalDiscount: disValue || 0,
      totalDiscountType: discountType || 0,
      quantityCheck:quantityCheck,
      status: "Draft",
      manualCheck: "No",
      state: customerState,
    };
    let newValidationMessage = "";
    if (!formData.customerName) {
      newValidationMessage += "Please select a customer \n";
    } else if (!formData.startOn) {
      newValidationMessage += "Please enter invoice date.\n";
    } else if (!formData.orderNumber) {
      newValidationMessage += "Please enter order number.\n";
    }
    row.forEach((item, index) => {
      if (
        item.itemDetails.trim() === "" ||
        item.rate.trim() === "" ||
        item.rate.trim() === "0.0" ||
        item.quantity.trim() === ""
      ) {
        newValidationMessage +=
          "Enter the valid item name, rate and quantity.\n";
      }
    });

    setValidationMessage1(newValidationMessage);

    // Display a single validation alert if necessary
    if (newValidationMessage) {
      window.scrollTo(0, 0); // Scroll to top
      return;
    }
    setIsLoading2(true);
    const response = await fetch(BASE_URL + `/insertRecurring`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "Recurring Invoice Created",
          });
          handleNavigation("RecurringInvoices");
          setIsLoading2(false);
        } else if (data.status === "error") {
          swal({
            icon: "error",
            title: data.responseMessage,
          });
          setIsLoading2(false);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: error.message,
        });
        setIsLoading2(false);
      });
  };

  const [showItemModal, setShowItemModal] = useState(false);
  const [itemName, setItemName] = useState("");

  const [itemData, setItemData] = useState({
    uniqueId: decryptedUniqueId,
    description: "",
  });

  const handleItemChange = (event) => {
    const { name, value } = event.target;
    setItemData({ ...itemData, [name]: value });
  };

  const handleItemClose = () => {
    setShowItemModal(false);
    setItemData({
      ...itemData,
      description: "",
    });
  };

  const [itemDescriptions, setItemDescriptions] = useState([]);

  const handleItem = (event) => {
    event.preventDefault();

    const newItemDescription = {
      itemDetails: itemName,
      description: itemData.description,
    };

    setItemDescriptions((prevDescriptions) => {
      const existingIndex = prevDescriptions.findIndex(
        (desc) => desc.itemDetails === itemName
      );

      if (existingIndex !== -1) {
        // Update existing description
        const updatedDescriptions = [...prevDescriptions];
        updatedDescriptions[existingIndex] = newItemDescription;
        // swal({
        //   icon: "success",
        //   title: "Description Updated",
        // });
        return updatedDescriptions;
      } else {
        // Add new description
        // swal({
        //   icon: "success",
        //   title: "Description Created",
        // });
        return [...prevDescriptions, newItemDescription];
      }
    });

    // Update the description2 in the row
    setRow((prevRows) => {
      return prevRows.map((row) =>
        row.itemDetails === itemName
          ? { ...row, description2: itemData.description }
          : row
      );
    });

    setShowItemModal(false);
  };

  const handleItemShow = (itemDetails) => {
    const itemDescription = itemDescriptions.find(
      (desc) => desc.itemDetails === itemDetails
    );
    if (itemDescription) {
      setItemData({ description: itemDescription.description });
    } else {
      setItemData({ description: "" });
    }
    setItemName(itemDetails);
    setShowItemModal(true);
  };

  const [dropdownData, setDropdownData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);

  
    const [allItemNames, setAllItemNames] = useState([]);

  const fetchItemData = (selectedItemId) => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);
    const jwtToken = localStorage.getItem("jwtToken");

    const postApiUrl = BASE_URL + `/getAllItemData`;

    fetch(postApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, vendorId: "" }),
    })
      .then((response) => response.json())
      .then((data) => {
        setAllItemNames(data.responseMessage);
        const responseData = data.responseMessage;
        // setDropdownData(responseData.map((item) => item));
        const filteredData = responseData.filter(
          (item) => item.id !== selectedItemId
        );
        if (filteredData.length !== responseData.length) {
          // If there's a match, update dropdownData with the filtered data
          setDropdownData(filteredData);
        } else {
          // If there's no match, set dropdownData with the whole response data
          setDropdownData(responseData.map((item) => item));
        }
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  };

  useEffect(() => {
    fetchItemData();
  }, []);

  const [searchIndex, setSearchIndex] = useState(0);

  useEffect(() => {
    const results = dropdownData.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(results);
  }, [searchTerm, dropdownData]);

  const handleSearchChange = (e, index) => {
    const value = e.target.value;
    const newRow = [...row];
    newRow[index].itemDetails = value;
    setSearchTerm(value);
    setSearchPerformed(value !== "");
    setRow(newRow);
    setSearchIndex(index);
  };

  const handleItemDetailsChange = (e, index) => {
    const value = e.target.value;
    const newRow = [...row];
    newRow[index].itemDetails = value;
    setRow(newRow);
    setSearchTerm(value);
    setSearchPerformed(value !== "");
    setSearchIndex(index);
    if (value) {
      fetchItemRate(value, index);
    } else {
      handleSearchChange(value, index);
    }
  };

  const handleItemSelect = (selectedItem, selectedItemId, index) => {
    setSearchResults([]);
    const newRow = [...row];
    newRow[index].itemDetails = selectedItem;
    setRow(newRow);
    fetchItemRate(selectedItemId, index);
  };

  const fetchItemRate = (itemId, index) => {
    const jwtToken = localStorage.getItem("jwtToken");
    const getApiUrl = BASE_URL + `/getItemData/${itemId}`;

    fetch(getApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const rate = data.data.salesPrice;
        const itemCode = data.data.itemCode;
        const description1 = data.data.description;
        const hsnSac = data.data.hsnCode;
        const itemName = data.data.name;
        const updatedRow = [...row];
        updatedRow[index].rate = rate;
        updatedRow[index].itemCode = itemCode;
        updatedRow[index].description1 = description1;
        updatedRow[index].hsnSac = hsnSac;
        updatedRow[index].itemDetails = itemName;
        setRow(updatedRow);
        setSearchResults([]);
        // handleAdd();
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  };

    const [searchTermItemCode, setSearchTermItemCode] = useState("");
     const [searchResultsItemCode, setSearchResultsItemCode] = useState([]);
     const [searchPerformedItemCode, setSearchPerformedItemCode] = useState(false);
     const [searchIndexItemCode, setSearchIndexItemCode] = useState(0);
   
     const handleItemCodeChange = (e, i) => {
       const value = e.target.value;
       const newRow = [...row];
       newRow[i].itemCode = value;
       setRow(newRow);
       setSearchTermItemCode(value);
       setSearchPerformedItemCode(value !== "");
       setSearchIndexItemCode(i);
   
       if (value) {
         fetchItemByCode(value, i);
       }
     };
   
     const handleItemCodeSelect = (selectedItem, selectedItemId, index) => {
       setSearchResultsItemCode([]);
       const newRow = [...row];
       newRow[index].itemCode = selectedItem;
       setRow(newRow);
       fetchItemRate(selectedItemId, index);
     };
   
     const fetchItemByCode = (itemCode, index) => {
       const results = allItemNames.filter(
         (item) =>
           item.itemCode &&
           item.itemCode.toLowerCase().includes(itemCode.toLowerCase())
       );
       setSearchResultsItemCode(results);
     };

  const handleHsnSacChange = (e, i) => {
    const { value } = e.target;
    const newRow = [...row];
    newRow[i] = { ...newRow[i], hsnSac: value };
    setRow(newRow);
  };

  const fetchBill = () => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");

    // Decrypt the uniqueId using your decryption method
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    // Prepare the data to send in the POST request
    const requestData = {
      // Include any other data you need to send in the request
      uniqueId: decryptedUniqueId,
      type: "invoice",
    };

    // Define the POST request options
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
        // Add any other headers if required
      },
      body: JSON.stringify(requestData), // Convert the data to JSON format
    };

    // Make the POST request to your API endpoint
    fetch(BASE_URL + `/getCurruntNumberList2`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setInvoiceNumberPrefix(data.responseMessage.prefix);
        setInvoiceNumberNext(data.responseMessage.numbers);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }; // Empty dependency array to fetch data once when the component mounts

  useEffect(() => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    fetch(BASE_URL + `/getCurruntNumberList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ type: "invoice", uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setInvoiceNumber(data.responseMessage);
        } else {
          console.error("Failed to fetch numberList:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching Number List:", error);
      });
  }, []);

  const [salesData, setSalesData] = useState({
    uniqueId: decryptedUniqueId,
    name: "",
    email: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSalesData({ ...salesData, [name]: value });
  };

  const getCurrentDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const getDueDate = (invoiceDate) => {
    const date = new Date(invoiceDate);
    date.setDate(date.getDate() + 7);
    return date.toISOString().split("T")[0];
  };

  const [invoiceDate, setInvoiceDate] = useState(getCurrentDate());
  const [dueDate, setDueDate] = useState(getDueDate(getCurrentDate()));
  const [neverExpires, setNeverExpires] = useState(true); // Default to true
  const [neverExpiresCheck, setNeverExpiresCheck] = useState("yes");

  const handleNeverExpiresChange = (e) => {
    const isChecked = e.target.checked;
    setNeverExpires(isChecked);
    if (!isChecked) {
      setDueDate(getDueDate(invoiceDate));
      setNeverExpiresCheck("no");
    } else {
      setNeverExpiresCheck("yes");
    }
  };

  const calculateDays = () => {
    if (selectedTerms === "Week") return 7;
    if (selectedTerms === "2 Week") return 14;
    if (selectedTerms === "Month") return 30;
    if (selectedTerms === "2 Month") return 60;
    if (selectedTerms === "3 Month") return 90;
    if (selectedTerms === "6 Month") return 180;
    if (selectedTerms === "Year") return 365;
    if (selectedTerms === "2 Year") return 730;
    if (selectedTerms === "3 Year") return 1095;
    // Add more conditions for other options if needed
    if (selectedTerms === "Custom") return 0;
    return 0; // Default value if none of the conditions match
  };

  const [inputValue, setInputValue] = useState("1"); // State to keep track of input value

  const handleInputChangeDays = (e) => {
    setInputValue(e.target.value);
  };

  const handleSelectChange = (selectedOption) => {
    setSelectTermsDays(selectedOption.value);
  };

  const calculateValue = () => {
    if (selectTermsDays === "Days") {
      return inputValue;
    } else if (selectTermsDays === "Weeks") {
      return inputValue * 7;
    } else if (selectTermsDays === "Months") {
      return inputValue * 30; // Assuming 30 days in a month for simplicity
    } else if (selectTermsDays === "Years") {
      return inputValue * 365; // Assuming 365 days in a year for simplicity
    } else {
      return "";
    }
  };

  const optionsCustomers = custNames.map((customer) => ({
    value: customer.id,
    label: customer.customerName,
  }));
  const [customerFormData, setCustomerFormData] = useState({
    uniqueId: decryptedUniqueId,
    customerType: "Business",
    status: "Active",
    someName: "Mr.",
    firstName: "",
    lastName: "",
    companyName: "",
    displayName:"",
    customerName: "",
    email: "",
    workphone: "",
    mobile: "",
    designation: "",
    department: "",
    website: "",
    currency: "INR- Indian Rupee",
    openingBalance: "0",
    paymentTerms: "",
    facebook: "",
    twitter: "",
    billAttention: "",
    billCountry: "India",
    billAddress1: "",
    billAddress2: "",
    billCity: "",
    billState: "Maharashtra",
    billZipcode: "",
    billPhone: "",
    billFax: "",
    shipAttention: "",
    shipCountry: "India",
    shipAddress1: "",
    shipAddress2: "",
    shipCity: "",
    shipState: "Maharashtra",
    shipZipcode: "",
    shipPhone: "",
    shipFax: "",
    gstin: "",
    pan: "",
    placeOfSupply: "[MH] - Maharashtra",
    taxable: "",
    reason: "N/A",
    activeStatus: "Active",
    gstTreatment: "",
    contactPerson: [
      {
        other: "",
        otherFirstname: "",
        otherLastname: "",
        otherEmail: "",
        otherWorkphone: "",
        otherMobile: "",
      },
    ],
  });
  const handleChange = (event) => {
    // setSelectedOption(event.target.value);
    // const { name, value } = event.target;
    // setCustomerFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));

    const { name, value } = event.target;
  
    setCustomerFormData((prevData) => {
      const newData = {
        ...prevData,
        [name]: value,
      };
      
      // If customerName is being changed, also update displayName with the same value
      if (name === 'customerName') {
        newData.displayName = value;
      }
      
      return newData;
    });
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [validationMessage, setValidationMessage] = useState("");

  const handleSaveClick = () => {
    const jwtToken = localStorage.getItem("jwtToken");
    let newValidationMessage = "";

    if (!customerFormData.customerName) {
      newValidationMessage += "Please enter a customer display name.\n";
    } else if (
      customerFormData.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customerFormData.email)
    ) {
      newValidationMessage += "Please enter a valid email address.\n";
    }

    setValidationMessage(newValidationMessage);

    // Display a single validation alert if necessary
    if (newValidationMessage) {
      // alert(newValidationMessage.trim()); // Trim trailing newline for better formatting
      return; // Exit function if validation fails
    }
    fetch(BASE_URL + "/createCustomer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(customerFormData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.responseCode === "200") {
          swal({
            icon: "success",
            title: "Customer Created",
            text: "",
          });
          setShow(false);
          fetchAllCustomers();
        } else if (data.responseCode === "400") {
          swal({
            icon: "error",
            title: "This email already exists, please insert another email.",
            text: "",
          });
          setShow(true);
        } else {
          swal({
            icon: "error",
            title: "Failed to Create Customer!",
            text: "",
          });
          setShow(true);
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: "Network Error",
          text: "An error occurred while communicating with the server.",
        });
        setShow(true);
      });
  };

  const optionsRepeatEvery = [
    { value: "Week", label: "Week" },
    { value: "2 Week", label: "2 Week" },
    { value: "Month", label: "Month" },
    { value: "2 Month", label: "2 Month" },
    { value: "3 Month", label: "3 Month" },
    { value: "6 Month", label: "6 Month" },
    { value: "Year", label: "Year" },
    { value: "2 Year", label: "2 Year" },
    { value: "3 Year", label: "3 Year" },
    { value: "Custom", label: "Custom" },
  ];

  const optionsTermsDays = [
    { value: "Days", label: "Days (D)" },
    { value: "Weeks", label: "Weeks (W)" },
    { value: "Months", label: "Months (M)" },
    { value: "Years", label: "Years (Y)" },
  ];

  const [startDate, setStartDate] = useState(new Date());
  const [startDate1, setStartDate1] = useState(new Date());

  useEffect(() => {
    setStartDate(new Date());
  }, []);

  const [dateValue, setDateValue] = useState("");
  const [dateValue1, setDateValue1] = useState("");

  const handleDate = (date) => {
    setStartDate(date);
    let normalFormat = date === null ? "" : normalDateFormat(date);
    setDateValue(normalFormat);
  };

  const normalDateFormat = (date) => {
    if (date) {
      return (
        ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (Number(date.getMonth()) + 1)).slice(-2) +
        "-" +
        date.getFullYear()
      );
    }
    return date;
  };

  const handleDate1 = (date) => {
    setStartDate1(date);
    let normalFormat = date === null ? "" : normalDateFormat(date);
    setDateValue1(normalFormat);
  };

  const optionPaymentTerms = [
    { value: "Net 15", label: "Net 15" },
    { value: "Net 30", label: "Net 30" },
    { value: "Net 45", label: "Net 45" },
    { value: "Net 60", label: "Net 60" },
    { value: "Due End Of The Month", label: "Due End Of The Month" },
    { value: "Due End Of Next Month", label: "Due End Of Next Month" },
    { value: "Due On Receipt", label: "Due On Receipt" },
    { value: "Custom", label: "Custom" },
  ];

  const optionsSalesPerson = salesPersonData.map((person) => ({
    value: person.id,
    label: person.name,
  }));

  const handlePaymentTerms = (selectedOption) => {
    setSelectedPaymentTerms(selectedOption.value);
    // updateDueDate(dateValue, selectedOption.value);
  };

  const [showSalesModal, setShowSalesModal] = useState(false);

  const handleSalesClose = () => setShowSalesModal(false);
  const handleSalesShow = () => setShowSalesModal(true);
  const [validationMessage2, setValidationMessage2] = useState("");

  const handleSalesPerson = (event) => {
    let newValidationMessage = "";

    if (!salesData.name) {
      newValidationMessage += "Please enter a name.\n";
    }

    setValidationMessage2(newValidationMessage);

    // Display a single validation alert if necessary
    if (newValidationMessage) {
      return; // Exit function if validation fails
    }
    event.preventDefault();

    fetch(BASE_URL + "/createSalesperson", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(salesData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "Sales Person Created",
          });
          setShowSalesModal(false);
          fetchSalesData();
        } else {
          swal({
            icon: "error",
            title: "Failed To Create Sales Person!",
          });
          setShowSalesModal(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        swal({
          icon: "error",
          title: "An Error Occured While Creating Sales Person ",
        });
        setShowSalesModal(true);
      });
  };
  const generateNamePairs = () => {
    const { someName, firstName, lastName, companyName } = customerFormData;
    const pairs = [];

    if (firstName && lastName) {
      pairs.push(`${someName} ${firstName} ${lastName}`);
      pairs.push(`${firstName} ${lastName}`);
      pairs.push(`${lastName} , ${firstName}`);
      pairs.push(`${companyName}`);
    }

    return pairs;
  };
  const fetchTermsData = () => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);
    const jwtToken = localStorage.getItem("jwtToken");

    const postApiUrl = BASE_URL + `/getCheckedTermsAndCondition`;

    fetch(postApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.responseCode;
        // setDropdownData(responseData.map((item) => item));
        setTermsAndCondition(responseData.join("") || "");
      })
      .catch((error) => {
        console.error("Error making POST request:", error);
      });
  };

  return (
    <>
      <div className="my-3">
        <div className="d-flex align-items-center ml-1 mt-4">
          <div
            className="cursor-pointer d-flex justify-content-center align-items-center"
            style={{
              backgroundColor: "white",
              borderRadius: "50%",
              height: "35px",
              width: "38px",
            }}
          >
            <ArrowBackIosIcon
              width={2}
              onClick={handleCancleClick}
              className="arrow-child"
            />
          </div>
          <div className="headitems ml-2">
            <h5
              className="ml-1 mb-0"
              style={{ letterSpacing: "1px", color: "#086bd5de" }}
            >
              New Recurring Invoice
            </h5>
          </div>
        </div>
      </div>
      {validationMessage1 && (
        <Alert severity="error" className="mt-0">
          {validationMessage1.split("\n").map((message, index) => (
            <div key={index}>{message}</div>
          ))}
        </Alert>
      )}{" "}
      <div className="card border-2 mt-3">
        <div className="pl-4 pr-4">
          <div className="row pt-3">
            <div className="salespersonbox">
              <div className="text-style">
                Customer Name <span className="valid"> *</span>
              </div>
              <Select
                options={optionsCustomers}
                value={optionsCustomers.find(
                  (option) => option.value === selectedCustomer
                )}
                onChange={(selectedOption) =>
                  handleCustomerChange(
                    selectedOption.label,
                    selectedOption.value
                  )
                }
                placeholder="Select Customer"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginTop: "10px",
                    width: "250px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    height: "46px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    height: "19px",
                  }),
                }}
              />
              <button type="button" class="btn p-0" onClick={handleShow}>
                <span
                  class="text-primary"
                  style={{ fontSize: "12px", fontWeight: "500" }}
                >
                  New Customer
                </span>
              </button>

              {/* Add customer popup*/}
              <Modal size="lg" show={show} onHide={handleClose}>
                <div class="modal-header d-flex align-items-center pb-2 pt-2">
                  <h5 class="modal-title fs-5" id="newcustomerPopup">
                    New Customer
                  </h5>
                  <button
                    type="button"
                    className="btn pr-0"
                    onClick={handleClose}
                  >
                    <ion-icon
                      name="close-circle-outline"
                      size="large"
                      style={{ width: "28px" }}
                    ></ion-icon>
                  </button>
                </div>
                <Modal.Body className="p-0 pb-3">
                  {validationMessage && (
                    <Alert severity="error" className="mt-0">
                      {validationMessage.split("\n").map((message, index) => (
                        <div key={index}>{message}</div>
                      ))}
                    </Alert>
                  )}{" "}
                  <div className="container">
                    <div className="row d-inline-flex">
                      <div className="modalinputchild">
                        <div className="text-style"> Salutation </div>
                        <select
                          className="form-control"
                          name="someName"
                          value={customerFormData.someName}
                          onChange={handleChange}
                          style={{
                            borderRadius: "9px",
                            backgroundColor: "#f5f5f5",
                            width: "200px",
                            height: "35px",
                            fontSize: "13px",
                            marginTop: "10px",
                          }}
                        >
                          <option value="Mr.">Mr.</option>
                          <option value="Mrs.">Mrs.</option>
                          <option value="Ms.">Ms.</option>
                          <option value="Miss.">Miss.</option>
                          <option value="Dr.">Dr.</option>
                        </select>
                      </div>
                      <div className="modalinputchild">
                        <div className="text-style">First Name</div>
                        <input
                          className="form-control"
                          placeholder="First Name"
                          name="firstName"
                          id="firstName"
                          value={customerFormData.firstName}
                          onChange={handleChange}
                          type="text"
                        />
                      </div>
                      <div className="modalinputchild">
                        <div className="text-style">Last Name</div>
                        <input
                          className="form-control"
                          placeholder="Last Name"
                          id="lastName"
                          name="lastName"
                          value={customerFormData.lastName}
                          onChange={handleChange}
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="row d-inline-flex pt-2">
                      <div className="modalinputchild">
                        <div className="text-style"> Customer Email </div>
                        <input
                          className="form-control"
                          placeholder="Customer Email"
                          name="email"
                          type="text"
                          value={customerFormData.email}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="modalinputchild">
                        <div className="text-style">
                          {" "}
                          Customer Display Name{" "}
                          <span style={{ color: "red" }}> *</span>
                        </div>
                        <input
                          className="form-control"
                          placeholder="Customer Display Name"
                          list="customerNames"
                          name="customerName"
                          value={customerFormData.customerName}
                          onChange={handleChange}
                          style={{
                            borderRadius: "7px",
                            backgroundColor: "#f5f5f5",
                            width: "200px",
                            height: "40px",
                            fontSize: "13px",
                            marginTop: "10px",
                          }}
                        />
                        <datalist id="customerNames">
                          {generateNamePairs().map((pair, index) => (
                            <option key={index} value={pair} />
                          ))}
                        </datalist>{" "}
                      </div>
                      <div className="modalinputchild">
                        <div className="text-style">Company Name</div>
                        <input
                          className="form-control"
                          placeholder="Add company name"
                          name="companyName"
                          type="text"
                          value={customerFormData.companyName}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="row d-inline-flex pt-2">
                      <div className="modalinputchild">
                        <div className="text-style">Customer Phone</div>
                        <input
                          className="form-control"
                          placeholder="Work Phone"
                          name="workphone"
                          type="text"
                          value={customerFormData.workphone}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="modalinputchild">
                        <div className="text-style">Mobile</div>
                        <input
                          className="form-control"
                          placeholder="Mobile"
                          name="mobile"
                          type="text"
                          value={customerFormData.mobile}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className="p-2">
                  <div className="modal-bottombtns">
                    <button
                      type="button"
                      class="modalbtn-1 btn mt-0"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      class="modalbtn-3 btn btn-primary"
                      onClick={handleSaveClick}
                    >
                      Create Customer
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
            <div className="inputchild">
              <div className="text-style">Profile Name</div>
              <input
                className="form-control"
                placeholder="Profile Name"
                id=""
                value={profileName}
                name="profileName"
                type="text"
                onChange={(e) => setProfileName(e.target.value)}
                style={{
                  padding: "12px",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "7px",
                  color: "black",
                }}
              />
            </div>

            <div className="inputchild">
              <div className="text-style">
                Order Number <span className="valid"> *</span>
              </div>
              <input
                className="form-control"
                placeholder="Order Number"
                name="orderNumber"
                value={orderNumber}
                onChange={(e) => setOrderNumber(e.target.value)}
                type="text"
                style={{
                  padding: "12px",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "7px",
                  color: "black",
                }}
              />
            </div>
          </div>

          <div className="row pt-3">
            <div className="salespersonbox">
              <div className="text-style">Repeat Every</div>
              <Select
                options={optionsRepeatEvery}
                value={optionsRepeatEvery.find(
                  (option) => option.value === selectedTerms
                )}
                onChange={handleTermsChange}
                placeholder="Select Terms"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginTop: "10px",
                    width: "250px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    height: "46px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    height: "19px",
                  }),
                }}
              />
            </div>

            <div className="repeatevery-inputchild">
              <input
                className="form-control text-right"
                type="text"
                value={
                  selectedTerms === "Custom"
                    ? calculateValue()
                    : calculateDays()
                }
                name="days"
                style={{
                  padding: "12px",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "7px",
                  color: "black",
                }}
                readOnly
              />
            </div>
            {selectedTerms === "Custom" && (
              <div className="repeatevery-inputchild">
                <input
                  className="form-control text-right"
                  type="text"
                  value={inputValue}
                  onChange={handleInputChangeDays}
                  name="days"
                  style={{
                    padding: "12px",
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    color: "black",
                  }}
                />
              </div>
            )}
            {selectedTerms === "Custom" && (
              <div className="salespersonbox d-flex align-items-end">
                <Select
                  options={optionsTermsDays}
                  value={optionsTermsDays.find(
                    (option) => option.value === selectTermsDays
                  )}
                  onChange={handleSelectChange}
                  placeholder="Select Term Days"
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      marginTop: "10px",
                      width: "170px",
                    }),
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: "#F6F6F6",
                      borderRadius: "7px",
                      height: "46px",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      height: "19px",
                    }),
                  }}
                />
              </div>
            )}
          </div>

          <div className="row pt-3">
            <div className="inputchild">
              <div className="text-style">
                Invoice Date <span className="valid"> *</span>
              </div>
              <div className="customDatePickerWidth">
                <DatePicker
                  className="form-control"
                  selected={startDate}
                  dateFormat="dd-MM-yyyy"
                  onChange={(date) => handleDate(date)}
                  style={{
                    padding: "12px",
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    color: "black",
                  }}
                />
              </div>
            </div>

            <div className="salespersonbox">
              <div className="text-style">Payment Terms</div>
              <Select
                // className="dropdown-field"
                options={optionPaymentTerms}
                value={optionPaymentTerms.find(
                  (option) => option.value === selectedPaymentTerms
                )}
                onChange={handlePaymentTerms}
                placeholder="Select Terms"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginTop: "10px",
                    width: "250px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    height: "46px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    height: "19px",
                  }),
                }}
              />
            </div>

            <div className="inputchild">
              <div className="text-style">Due Date </div>
              <div className="d-flex flex-column flex-md-row align-items-center">
                <div className="customDatePickerWidth mb-3 mb-md-0 mr-md-3">
                  <DatePicker
                    className="form-control"
                    selected={neverExpires ? "" : startDate1}
                    dateFormat="dd-MM-yyyy"
                    onChange={(date) => handleDate1(date)}
                    style={{
                      padding: "12px",
                      backgroundColor: "#F6F6F6",
                      borderRadius: "7px",
                      color: "black",
                    }}
                    disabled={neverExpires}
                  />
                </div>
                <div className="checkbox-container">
                  <div className="d-flex align-items-end">
                    <input
                      type="checkbox"
                      checked={neverExpires}
                      onChange={handleNeverExpiresChange}
                    />
                    <label
                      className="form-label required mb-0 ml-1"
                      style={{ width: "100px" }}
                    >
                      Never Expires
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-3">
            <div className="salespersonbox">
              <div className="text-style">Salesperson</div>
              <Select
                // className="dropdown-field"
                options={optionsSalesPerson}
                value={optionsSalesPerson.find(
                  (option) => option.value === selectedSalesPerson
                )}
                onChange={(selectedOption) =>
                  handleSalesPersonChange(
                    selectedOption.label,
                    selectedOption.value
                  )
                }
                placeholder="Select a SalesPerson"
                styles={{
                  container: (provided) => ({
                    ...provided,
                    marginTop: "10px",
                    width: "250px",
                  }),
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: "#F6F6F6",
                    borderRadius: "7px",
                    height: "46px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    height: "19px",
                  }),
                }}
              />
              <button type="button" class="btn p-0" onClick={handleSalesShow}>
                <span
                  class="text-primary"
                  style={{ fontSize: "12px", fontWeight: "500" }}
                >
                  New Sales Person
                </span>
              </button>

              {/*Sales Person Popup*/}
              <Modal show={showSalesModal} onHide={handleSalesClose}>
                <div class="modal-header d-flex align-items-center pb-2 pt-2">
                  <h5 class="modal-title fs-5" id="salespersonHead">
                    Add Sales Person
                  </h5>
                  <button
                    type="button"
                    className="btn pr-0"
                    onClick={handleSalesClose}
                  >
                    <ion-icon
                      name="close-circle-outline"
                      size="large"
                      style={{ width: "28px" }}
                    ></ion-icon>
                  </button>
                </div>
                <Modal.Body>
                  {validationMessage2 && (
                    <Alert severity="error" className="mt-0">
                      {validationMessage2.split("\n").map((message, index) => (
                        <div key={index}>{message}</div>
                      ))}
                    </Alert>
                  )}{" "}
                  <div className="row pt-2">
                    <div className="modalsalesinput">
                      <label className="form-label">
                        <span style={{ color: "red" }}>Name *</span>
                      </label>
                      <input
                        className="form-control"
                        placeholder="Name"
                        id="name"
                        name="name"
                        type="text"
                        value={salesData.name}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="row pt-4">
                    <div className="modalsalesinput">
                      <label className="form-label">
                        <span style={{ color: "#0b0a0ab5" }}>Email</span>
                      </label>
                      <input
                        className="form-control"
                        placeholder="Email"
                        id="email"
                        name="email"
                        type="text"
                        value={salesData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className="p-2">
                  <div className="modal-bottombtns">
                    <button
                      type="button"
                      class="modalbtn-1 btn mt-0"
                      onClick={handleSalesClose}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      class="modalbtn-3 btn btn-primary"
                      onClick={handleSalesPerson}
                      data-bs-dismiss="modal"
                    >
                      Create Sales Person
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>

            <div className="subjectbox ml-3">
              <div className="text-style">Subject</div>
              <input
                type="text"
                className="form-control subject-textarea"
                placeholder="Subject..."
                name="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                style={{ width: "33.78vw" }}
              />
            </div>
          </div>

          <>
            <div className="">
              <div>
                <Row className="mt-4">
                  <Col md="3">
                    <label
                      className="text-primary"
                      style={{ fontSize: 14, fontWeight: "600" }}
                    >
                      ITEM INFO
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Card className="mb-2">
                      <div className="" style={{ overflowX: "auto" }}>
                        <table
                          className="table table-bordered mb-0"
                          style={{
                            width: "100%",
                          }}
                        >
                          <thead className="text-center">
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "350px",
                                }}
                              >
                                ITEM DETAILS
                              </th>
                               <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  ITEM CODE
                                </th>
                              {bussinessRegistered === "YES" && (
                                <th
                                  scope="col"
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  HSN/SAC
                                </th>
                              )}
                              <th
                                scope="col"
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                PER
                              </th>
                              {quantityCheck === "YES" && (
                              <th
                                scope="col"
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                QUANTITY{" "}
                              </th>
                              )}
                              <th
                                scope="col"
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "100px",
                                }}
                              >
                                RATE
                              </th>
                              {discountCheck === "YES" && (
                                <th
                                  scope="col"
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  DISCOUNT
                                </th>
                              )}

                              {bussinessRegistered === "YES" && (
                                <th
                                  scope="col"
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "100px",
                                  }}
                                >
                                  TAX
                                </th>
                              )}

                              <th
                                scope="col"
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "50px",
                                }}
                              >
                                AMOUNT
                              </th>
                              <th
                                scope="col"
                                style={{
                                  whiteSpace: "nowrap",
                                  minWidth: "50px",
                                }}
                              >
                                ACTION
                              </th>
                            </tr>
                          </thead>

                          {row.map((data, i) => {
                            const amount = calculateAmount(data, data.tax);
                            const taxinAmount = calculateTAX(data);
                                const totalAmountWithTax = parseFloat(amount) + parseFloat(taxinAmount);
                            const disRup = calculateDisRupees(data);
                            const totaldis = parseFloat(disRup);
                            const itemDescription = itemDescriptions.find(
                              (desc) => desc.itemDetails === data.itemDetails
                            );
                            return (
                              <tbody key={i}>
                                <tr>
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        className="form-control noBorder"
                                        placeholder="Search items..."
                                        value={data.itemDetails}
                                        onChange={(e) =>
                                          handleItemDetailsChange(e, i)
                                        }
                                        style={{ flex: 1 }}
                                      />
                                      {data.itemDetails && (
                                        <button
                                          type="button"
                                          className="btn p-0"
                                          onClick={() =>
                                            handleItemShow(data.itemDetails)
                                          }
                                          style={{ marginLeft: "10px" }}
                                        >
                                          <span
                                            className="text-primary"
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "500",
                                            }}
                                          >
                                            Edit
                                          </span>
                                        </button>
                                      )}
                                    </div>
                                    {itemDescription && (
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          color: "#6c757d",
                                          whiteSpace: "pre-line", // This preserves the line breaks
                                        }}
                                      >
                                        {itemDescription.description}
                                      </div>
                                    )}
                                    {searchPerformed &&
                                      data.itemDetails &&
                                      i === searchIndex && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            zIndex: 9999, // Higher than scrollbar
                                            top: "100%", // Position below input
                                            left: 0,
                                            width: "60%",
                                          }}
                                        >
                                          {searchResults.length === 0 && ""}
                                          {searchResults.length > 0 && (
                                            <ul
                                              style={{
                                                listStyleType: "none",
                                                padding: 0,
                                                position: "absolute",
                                                top: "calc(100% + 10px)",
                                                left: 0,
                                                zIndex: 1000,
                                                backgroundColor: "#FFF",
                                                boxShadow:
                                                  "0px 0px 10px rgba(0, 0, 0, 0.2)",
                                                borderRadius: "5px",
                                                width: "100%",
                                                maxHeight: "200px", // Set a max height for the list
                                                overflowY: "auto", // Enable vertical scrolling
                                              }}
                                            >
                                              {searchResults.map(
                                                (result, index) => (
                                                  <li
                                                    key={index}
                                                    onClick={() =>
                                                      handleItemSelect(
                                                        result.name,
                                                        result.id,
                                                        i
                                                      )
                                                    }
                                                    onMouseEnter={(e) => {
                                                      e.target.style.backgroundColor =
                                                        "#408dfb";
                                                      e.target.style.color =
                                                        "#FFF";
                                                      e.target.style.borderRadius =
                                                        "5px"; // Apply border radius on hover
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.target.style.backgroundColor =
                                                        "";
                                                      e.target.style.color =
                                                        "#000";
                                                      e.target.style.borderRadius =
                                                        ""; // Reset border radius
                                                    }}
                                                    style={{
                                                      padding: "12px",
                                                      cursor: "pointer",
                                                      whiteSpace: "nowrap", // Prevent text from overflowing
                                                      overflow: "hidden", // Hide overflow text
                                                      textOverflow: "ellipsis", // Add ellipsis for overflowing text
                                                    }}
                                                  >
                                                   <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          marginBottom: "4px",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {result.name}
                                                        </span>
                                                        <span>
                                                          Code:{" "}
                                                          {result.itemCode ||
                                                            "N/A"}
                                                        </span>
                                                      </div>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                        }}
                                                      >
                                                        <span>
                                                          Make:{" "}
                                                          {result.make || "N/A"}
                                                        </span>
                                                        <span>
                                                          Stock:{" "}
                                                          {result.openingStock ||
                                                            "N/A"}
                                                        </span>
                                                      </div>
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          )}
                                        </div>
                                      )}
                                  </td>

                                  <Modal
                                    show={showItemModal}
                                    onHide={handleItemClose}
                                  >
                                    <div class="modal-header d-flex align-items-center pb-2 pt-2">
                                      <h5
                                        class="modal-title fs-5"
                                        id="salespersonHead"
                                      >
                                        Add Item Description
                                      </h5>
                                      <button
                                        type="button"
                                        className="btn pr-0"
                                        onClick={handleItemClose}
                                      >
                                        <ion-icon
                                          name="close-circle-outline"
                                          size="large"
                                          style={{ width: "28px" }}
                                        ></ion-icon>
                                      </button>
                                    </div>
                                    <Modal.Body>
                                      {/* <div className="row pt-2">
                                          <div className="modalsalesinput">
                                            <label className="form-label">
                                              <span
                                                style={{ color: "#0b0a0ab5" }}
                                              >
                                                Item
                                              </span>
                                            </label>
                                            <input
                                              className="form-control"
                                              placeholder="Name"
                                              id="name"
                                              name="name"
                                              type="text"
                                              value={itemName}
                                              readOnly
                                            />
                                          </div>
                                        </div> */}
                                      {/* <div className="row pt-4">
                                          <div className="modalsalesinput">
                                            <label className="form-label">
                                              <span
                                                style={{ color: "#0b0a0ab5" }}
                                              >
                                                Description
                                              </span>
                                            </label>
                                            <textarea
                            className="cn-textarea"
                            type="text"
                            placeholder="Item Description"
                            name="customerNote"
                            value={itemData.description}
                            onChange={handleItemChange}
                            rows={1}                            
                            style={{
                              backgroundColor: "#F6F6F6",
                              borderRadius: "9px",
                              padding: "12px",
                              width:'100%'
                            }}
                          />
                                          </div>
                                        </div> */}
                                      <Row>
                                        <Col md="12">
                                          <div className="row pt-2">
                                            <div className="col-lg-6">
                                              <label
                                                className="form-label"
                                                style={{
                                                  fontSize: "14px",
                                                  color: "grey",
                                                  borderRadius: "7px",
                                                }}
                                              >
                                                Item
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-lg-12 pl-0 pr-0">
                                            <input
                                              className="form-control"
                                              placeholder="Name"
                                              id="name"
                                              name="name"
                                              type="text"
                                              value={itemName}
                                              readOnly
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <div className="row pt-2">
                                            <div className="col-lg-6">
                                              <label
                                                className="form-label"
                                                style={{
                                                  fontSize: "14px",
                                                  color: "grey",
                                                  borderRadius: "7px",
                                                }}
                                              >
                                                Description
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-lg-12 pl-0 pr-0">
                                            <textarea
                                              className="cn-textarea"
                                              type="text"
                                              placeholder="Item Description"
                                              name="description"
                                              value={itemData.description}
                                              onChange={handleItemChange}
                                              rows={2}
                                              style={{
                                                backgroundColor: "#F6F6F6",
                                                borderRadius: "9px",
                                                padding: "12px",
                                                width: "100%",
                                              }}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Modal.Body>
                                    <Modal.Footer className="p-2">
                                      <div className="modal-bottombtns">
                                        <button
                                          type="button"
                                          class="modalbtn-1 btn mt-0"
                                          onClick={handleItemClose}
                                        >
                                          Close
                                        </button>
                                        <button
                                          type="button"
                                          class="modalbtn-3 btn btn-primary"
                                          onClick={handleItem}
                                          data-bs-dismiss="modal"
                                        >
                                          Add Description
                                        </button>
                                      </div>
                                    </Modal.Footer>
                                  </Modal>
                                 <td style={{ whiteSpace: "nowrap" }}>
                                      <div style={{ position: "relative" }}>
                                        <input
                                          className="form-control noArrowNumber noBorder"
                                          value={data.itemCode || ""}
                                          name="itemCode"
                                          type="text"
                                          placeholder="Item Code"
                                          onChange={(e) =>
                                            handleItemCodeChange(e, i)
                                          }
                                          style={{ flex: 1 }}
                                        />
                                      </div>
                                      {searchPerformedItemCode &&
                                        data.itemCode &&
                                        i === searchIndexItemCode && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              zIndex: 9999,
                                              top: "100%",
                                              left: 0,
                                              width: "60%", // Increased width
                                            }}
                                          >
                                            {searchResultsItemCode.length >
                                              0 && (
                                              <ul
                                                style={{
                                                  listStyleType: "none",
                                                  padding: 0,
                                                  position: "absolute",
                                                  top: "calc(100% + 10px)",
                                                  left: 0,
                                                  zIndex: 1000,
                                                  backgroundColor: "#FFF",
                                                  boxShadow:
                                                    "0px 0px 10px rgba(0, 0, 0, 0.2)",
                                                  borderRadius: "5px",
                                                  width: "100%",
                                                  maxHeight: "300px",
                                                  overflowY: "auto",
                                                }}
                                              >
                                                {searchResultsItemCode.map(
                                                  (result, index) => (
                                                    <li
                                                      key={index}
                                                      onClick={() =>
                                                        handleItemCodeSelect(
                                                          result.itemCode,
                                                          result.id,
                                                          i
                                                        )
                                                      }
                                                      onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor =
                                                          "#408dfb";
                                                        e.target.style.color =
                                                          "#FFF";
                                                        e.target.style.borderRadius =
                                                          "5px";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor =
                                                          "";
                                                        e.target.style.color =
                                                          "#000";
                                                        e.target.style.borderRadius =
                                                          "";
                                                      }}
                                                      style={{
                                                        padding: "12px",
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow:
                                                          "ellipsis",
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          marginBottom: "4px",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            fontWeight: "bold",
                                                          }}
                                                        >
                                                          {result.name}
                                                        </span>
                                                        <span>
                                                          Code:{" "}
                                                          {result.itemCode ||
                                                            "N/A"}
                                                        </span>
                                                      </div>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                        }}
                                                      >
                                                        <span>
                                                          Make:{" "}
                                                          {result.make || "N/A"}
                                                        </span>
                                                        <span>
                                                          Stock:{" "}
                                                          {result.openingStock ||
                                                            "N/A"}
                                                        </span>
                                                      </div>
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            )}
                                          </div>
                                        )}
                                    </td>

                                  {bussinessRegistered === "YES" && (
                                    <td style={{ whiteSpace: "nowrap" }}>
                                      <input
                                        className="form-control noArrowNumber noBorder"
                                        name="hsnSac"
                                        type="text"
                                        value={data.hsnSac || ""}
                                        onChange={(e) =>
                                          handleHsnSacChange(e, i)
                                        }
                                        style={{ backgroundColor: "white" }}
                                      />
                                    </td>
                                  )}

                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control noBorder"
                                      value={data.per || "1"}
                                      name="per"
                                      type="text"
                                      readOnly
                                      // onChange={(e) =>
                                      //   handleQuantityChange(e, i)
                                      // }
                                      style={{ backgroundColor: "white" }}
                                    />
                                  </td>
                                  {quantityCheck === "YES" && (
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control noBorder"
                                      value={data.quantity || "1"}
                                      name="quantity"
                                      type="text"
                                      onChange={(e) =>
                                        handleQuantityChange(e, i)
                                      }
                                      style={{ backgroundColor: "white" }}
                                    />
                                  </td>
                                  )}
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <input
                                      className="form-control noArrowNumber noBorder"
                                      name="rate"
                                      value={data.rate || "0"}
                                      type="text"
                                      onChange={(e) => handleRateChange(e, i)}
                                      style={{ backgroundColor: "white" }}
                                    />
                                  </td>
                                  {discountCheck === "YES" && (
                                    <td
                                      style={{
                                        whiteSpace: "nowrap",
                                        padding: "0px",
                                      }}
                                    >
                                      <div className="d-flex justify-content-center">
                                        <input
                                          className="form-control col-md-6 noBorder"
                                          value={data.discount || "0"}
                                          type="text"
                                          onChange={(e) =>
                                            handleDiscountChange(e, i)
                                          }
                                          name="discount"
                                          style={{
                                            textAlign: "center",
                                            padding: "0px",
                                            marginRight: "5px",
                                            backgroundColor: "white",
                                          }}
                                        />
                                        <select
                                          className="border-0 noBorder"
                                          value={data.discountType}
                                          onChange={(e) =>
                                            handleDiscountChange(e, i)
                                          }
                                          name="discountType"
                                        >
                                          <option value="₹">₹</option>
                                          <option value="%">%</option>
                                        </select>
                                      </div>
                                    </td>
                                  )}
                                  {bussinessRegistered === "YES" && (
                                    <td style={{ whiteSpace: "nowrap" }}>
                                      <select
                                        className="form-control"
                                        value={data.tax}
                                        onChange={(e) => handleTaxChange(e, i)}
                                      >
                                        <option value="0">N/A</option>
                                        <option value="0">0 GST [0%]</option>
                                        <option value="5">5 GST [5%]</option>
                                        <option value="12">12 GST [12%]</option>
                                        <option value="18">18 GST [18%]</option>
                                        <option value="28">28 GST [28%]</option>
                                      </select>
                                    </td>
                                  )}
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <span>
                                      {parseFloat(totalAmountWithTax).toFixed(
                                        2
                                      )}
                                    </span>
                                  </td>

                                  <td
                                    className="text-center"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    <button
                                      className="btn px-2 btn-light icon-border btn-sm"
                                      type="button"
                                      onClick={() => handleDeleteRow(i)}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </td>
                                  {/* <th>{parseFloat(totaldis).toFixed(2)}</th> */}
                                </tr>
                              </tbody>
                            );
                          })}
                        </table>
                      </div>
                    </Card>
                  </Col>
                </Row>
                <button className="btn addline-btn" onClick={handleAdd}>
                  + Add Another Line
                </button>
              </div>

              <div className="grid-container">
                <div className="flex-item pb-0 pl-0 d-flex flex-column-reverse">
                  <div className="row pt-3">
                    <div className="col-lg-6">
                      <label
                        className="form-label required mg-b-0"
                        style={{ fontSize: "14px", color: "grey" }}
                      >
                        Customer Notes
                      </label>
                    </div>
                    <div className="col-lg-12">
                      <textarea
                        className="cn-textarea"
                        placeholder="Customer Notes..."
                        name="customerNotes"
                        value={customerNote || "Thank You For Business."}
                        onChange={(e) => setCustomerNote(e.target.value)}
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <div className="subtotal-box">
                  <div className="flex-item">
                    <div className="row">
                      <div className="col-lg-8">
                        <label className="form-label required">Sub Total</label>
                      </div>
                      <div className="col-lg-4 text-end pl-0">
                        <label className="form-label required">
                          {calculateSubTotal()}
                        </label>
                      </div>
                    </div>
                    {discountCheck === "YES" && (
                      <div className="row d-flex align-items-baseline mt-1">
                        <div className="col-lg-5 pr-0">
                          <label>Discount</label>
                        </div>
                        <div className="col-lg-3 pl-0 d-flex">
                          <input
                            className="form-control"
                            value={disAllValue || "0"}
                            type="number"
                            name="discount"
                            onChange={handleDisAllValueChange}
                            style={{
                              height: "36px",
                              padding: "3px 8px",
                              backgroundColor: "#F6F6F6",
                            }}
                          />
                          <select
                            className="form-control ml-1 pl-0 rounded"
                            name="discountType"
                            value={discountType}
                            onChange={handleDiscountTypeChange}
                            style={{
                              height: "36px",
                              width: "40px",
                              padding: "3px 8px",
                              backgroundColor: "#F6F6F6",
                            }}
                          >
                            <option disabled>Select</option>
                            <option value="₹">₹</option>
                            <option value="%">%</option>
                          </select>
                        </div>
                        <div className="col-lg-4 text-end pl-0">
                          <label className="form-label textColor-red">
                            {" "}
                            {isNaN(parseFloat(disValue).toFixed(2))
                              ? "0.00"
                              : -parseFloat(disValue).toFixed(2)}
                          </label>
                        </div>
                      </div>
                    )}
                    {bussinessRegistered === "YES" && (
                      <div className="row mt-3">
                        {userState.state !== customerState && (
                          <>
                            {calculateIGSTForTax().map((taxResult, index) => (
                              <React.Fragment key={index}>
                                <div className="col-lg-8">
                                  <label className="form-label required">
                                    IGST ({(taxResult.taxRate * 100).toFixed(0)}
                                    %)
                                  </label>
                                </div>
                                <div className="col-lg-4 text-end pl-0">
                                  <label className="form-label required">
                                    {taxResult.totalIGST.toFixed(2)}
                                  </label>
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        )}

                        {userState.state === customerState && (
                          <>
                            {Object.entries(calculateGroupedSGSTandCGST()).map(
                              ([taxRate, taxData], index) => (
                                <React.Fragment key={index}>
                                  <div className="col-lg-8">
                                    <label className="form-label required">
                                      CGST (
                                      {((parseFloat(taxRate) * 100) / 2)
                                        .toFixed(1)
                                        .replace(/\.0$/, "")}
                                      %)
                                    </label>
                                  </div>
                                  <div className="col-lg-4 text-end pl-0">
                                    <label className="form-label required">
                                      {taxData.totalCGST.toFixed(2)}
                                    </label>
                                  </div>
                                  <div className="col-lg-8 mt-2">
                                    <label className="form-label required">
                                      SGST (
                                      {((parseFloat(taxRate) * 100) / 2)
                                        .toFixed(1)
                                        .replace(/\.0$/, "")}
                                      %)
                                    </label>
                                  </div>
                                  <div className="col-lg-4 text-end pl-0 mt-2">
                                    <label className="form-label required">
                                      {taxData.totalSGST.toFixed(2)}
                                    </label>
                                  </div>
                                </React.Fragment>
                              )
                            )}
                          </>
                        )}
                      </div>
                    )}
                    <div className="row mt-3 mb-3">
                      <div className="col-lg-5 pr-0">
                        <input
                          className="form-control col-md-10"
                          type="text"
                          placeholder="Adjustment"
                          value={adjustmentLabel}
                          onChange={(e) => setAdjustmentLabel(e.target.value)}
                          name="adjustmentLabel"
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderRadius: "10px",
                            color: "black",
                            "::placeholder": {
                              color:
                                "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                            },
                          }}
                        />
                      </div>
                      <div className="col-lg-5 pl-0">
                        <input
                          className="form-control col-md-10"
                          type="text"
                          placeholder="Label"
                          value={adjustmentValue}
                          onChange={(e) => setAdjustmentValue(e.target.value)}
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderRadius: "10px",
                            color: "black",
                            "::placeholder": {
                              color:
                                "var(--Black-light-text, rgba(0, 0, 0, 0.25))",
                            },
                          }}
                        />
                      </div>
                      <div className="col-lg-2 text-end pl-0">
                        <label className="form-label mt-2">
                          {oppositeValue}
                        </label>
                      </div>
                    </div>
                    <hr />
                    <div className="mt-3 d-flex justify-content-between">
                      <label className="form-label required ">
                        Total (₹) :
                      </label>
                      <label className="form-label required">
                        {calculateTotal()}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="mt-4" />

              <div className="row pt-2 align-items-center">
                <div className="col-lg-6">
                  <label
                    className="form-label required mg-b-0"
                    style={{ fontSize: "14px", color: "grey" }}
                  >
                    Terms & Conditions
                  </label>
                </div>
                <div className="col-lg-12">
                  {/* <textarea
                    className="invoicetextarea"
                    placeholder="Add your terms & condition"
                    name="termsAndCondition"
                    value={termsAndCondition || ""}
                    onChange={(e) => setTermsAndCondition(e.target.value)}
                    type="text"
                    rows={4}
                    style={{
                      backgroundColor: "#F6F6F6",
                      borderRadius: "9px",
                      padding: "12px",
                      height: "100%",
                    }}
                  /> */}

                  <ReactQuill
                    value={termsAndCondition}
                    onChange={handleEditorChange} // Function to update state
                    theme="snow" // Use "bubble" for a minimal UI
                    style={{ height: "300px", marginBottom: "50px" }}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headers
                        [{ font: [] }], // Font options
                        [{ size: [] }], // Font size
                        [{ color: [] }, { background: [] }], // Text color & background
                        ["bold", "italic", "underline", "strike"], // Basic text styles
                        [{ script: "sub" }, { script: "super" }], // Subscript & superscript
                        [{ align: [] }], // Text alignment
                        [{ list: "ordered" }, { list: "bullet" }], // Lists
                        [{ indent: "-1" }, { indent: "+1" }], // Indentation
                        ["blockquote", "code-block"], // Blockquote & code block
                        ["link", "image", "video"], // Media links
                        ["clean"], // Remove formatting
                      ],
                    }}
                    formats={[
                      "header",
                      "font",
                      "size",
                      "color",
                      "background",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "script",
                      "align",
                      "list",
                      "bullet",
                      "indent",
                      "blockquote",
                      "code-block",
                      "link",
                      "image",
                      "video",
                    ]}
                  />
                  <i className="text-muted">
                    This Terms and Condition will be displayed on the recurring
                    invoice
                  </i>
                </div>
              </div>
            </div>
          </>
        </div>

        <div className="text-right mt-5 mb-4" style={{ marginRight: "1.5rem" }}>
          <button className="btn-1 btn mt-0" onClick={handleCancleClick}>
            Cancel
          </button>
          <button
            className="btn-1 btn mt-0"
            onClick={insertDataIntoDatabaseAsDraft}
          >
            {isLoading2 ? "Saving..." : "Save as Draft"}
          </button>
          <button
            className="btn-3 btn btn-primary"
            onClick={insertDataIntoDatabase}
          >
            {isLoading ? "Saving..." : "Create Invoice"}
          </button>
        </div>
      </div>
    </>
  );
}

export default RecurringInvoiceNew;
